import { render, staticRenderFns } from "./onlineClass.vue?vue&type=template&id=0d537571&scoped=true&"
import script from "./onlineClass.vue?vue&type=script&lang=js&"
export * from "./onlineClass.vue?vue&type=script&lang=js&"
import style0 from "./onlineClass.vue?vue&type=style&index=0&id=0d537571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d537571",
  null
  
)

export default component.exports